import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";

@inheritSerialization(BaseEntity)
export default class GroupWhatApps extends BaseEntity {

	@serialize
	@deserialize
	public kode: string = "";

	@serialize
	@deserialize
	public link: string = "";

}
